module.exports = __webpack_public_path__ + "assets/img/icon-save-money.8bedcc6e.svg";